<template>
  <div
    :style="{zIndex: 0, width: this.allWidth ? '100%' : 'unset', marginTop: `${this.marginTop || 0}px`, ...this.columnWidthsVars}"
  >
    <!-- Страничный режим (pageMode, как списки в app.buildest.kz): прокручивается вся страница, а не таблица;
         панель с заголовком, поиском, фильтрами и кнопками уходит вверх вместе со списком.
         Включается сам для основных списков (:sticky-header="true" вне модалок) или явно :page-scroll="true". -->
    <div v-if="this.pageMode" class="ms-list-toolbar">
      <h1 v-if="!!title" class="ms-list-toolbar__title">
        {{ title }}
        <span class="ms-count">{{ this.countLabel }}</span>
      </h1>
      <span v-else-if="!this.hideTopTitle" class="ms-count">Всего: {{ this.countLabel }}</span>
      <slot name="top-after-title"></slot>
      <label v-if="this.showSearch" class="ms-search">
        <i class="fa-solid fa-magnifying-glass" aria-hidden="true" />
        <input
          type="text"
          :value="this.searchInput"
          placeholder="Поиск"
          @input="(e) => this.onSearchInput(e.target.value)"
        />
        <button
          v-if="!!this.searchInput"
          type="button"
          class="ms-search__clear"
          title="Очистить"
          @click.prevent="this.clearSearch"
        >
          <i class="fa-solid fa-xmark" aria-hidden="true" />
        </button>
      </label>
      <slot name="toolbar"></slot>
      <div class="ms-list-toolbar__spacer" />
      <slot name="top-right"></slot>
      <slot name="toolbar-right"></slot>
      <button
        v-if="this.columnWidths"
        type="button"
        class="ms-btn ms-btn--icon"
        title="Сбросить ширину колонок"
        @click="this.resetColumnWidths"
      >
        <i class="fa-solid fa-arrows-left-right" aria-hidden="true" />
      </button>
      <button
        v-if="this.rowViewEnabled"
        type="button"
        :class="['ms-btn', 'ms-btn--icon', {'ms-btn--active': this.rowViewMode}]"
        :title="this.rowViewMode ? 'Выключить просмотр' : 'Просмотр: нажмите на строку, чтобы увидеть все поля'"
        :aria-pressed="this.rowViewMode"
        @click="this.toggleRowViewMode"
      >
        <i class="fa-solid fa-eye" aria-hidden="true" />
      </button>
      <button
        v-if="this.updateData"
        type="button"
        class="ms-btn ms-btn--icon"
        title="Обновить"
        @click="this.updateData"
      >
        <i class="fa-solid fa-rotate-right" aria-hidden="true" />
      </button>
      <button
        v-if="this.showHeaderAdd"
        type="button"
        class="ms-btn ms-btn--primary"
        :disabled="this.headerAddDisabled"
        @click="() => onAddClick && onAddClick()"
      >
        <i class="fa-solid fa-plus" aria-hidden="true" />
        {{ this.addBtnTitle || 'Добавить' }}
      </button>
    </div>
    <div v-if="this.rowViewMode" class="custom-table__view-hint">
      <i class="fa-solid fa-hand-pointer" aria-hidden="true" />
      Режим просмотра: нажмите на строку, чтобы открыть все поля
      <button type="button" class="ms-search__clear" title="Выключить" @click="this.toggleRowViewMode">
        <i class="fa-solid fa-xmark" aria-hidden="true" />
      </button>
    </div>
    <span
      v-if="!this.pageMode && this.paginationPosition !== 'bottom' && !this.hideTopTitle"
      class="pagination__title"
      >{{ this.paginationTitle }}</span
    >
    <q-table
      :class="{'custom-table scrollbar__wrapper': true, 'custom-table--natural': !!this.naturalHeight, 'custom-table__bordered': !!this.bordered, 'custom-table__hoverless': !!this.hoverless, 'custom-table__striped': this.striped === false, 'custom-table__expand': !!this.expand, 'custom-table__small': !!this.small, 'custom-table__smallFont': !!this.smallFont, 'custom-table__default': !this.expand, 'my-sticky-header-table': this.stickyHeader !== false && !!this.rowsData?.length && !this.pageMode, 'sticky-last-column': this.stickyLastColumn === true && !!this.rowsData?.length, 'custom-table--page': this.pageMode, 'custom-table--viewmode': this.rowViewMode, 'custom-table--resizable': this.columnsResizable, 'custom-table--resized': !!this.columnWidths, 'custom-table--page-sticky-head': this.pageMode && !!this.pageStickyHeader }"
      :table-class="{expand: !!this.expand, 'not_expand': !this.expand}"
      :rows="renderedRowsData"
      :columns="columns"
      :title="this.pageMode ? undefined : title"
      :wrap-cells="!this.pageMode"
      :dense="this.dense || false"
      :style="{maxHeight: this.maxHeightData, minHeight: this.withoutHead || this.pageMode ? 'unset' :'95px'}"
      :row-key="rowKey"
      :virtual-scroll="!!virtualScroll"
      :virtual-scroll-item-size="Number(virtualScrollItemSize) || 120"
      :virtual-scroll-sticky-size-start="virtualScroll ? 48 : 0"
      :rows-per-page-options="virtualScroll ? [0] : undefined"
      :pagination="tablePagination"
      no-results-label="Ничего не найдено"
      no-data-label="Ничего не найдено"
      loading-label="Загрузка"
      :hide-pagination="true"
      :hide-bottom="!!computedRowsData?.length"
      :loading="this.loading"
      :hide-header="!!this.withoutHead"
      :separator="separator || (this.pageMode ? 'horizontal' : 'cell')"
      v-on="{
        ...(this.rowViewMode && !this.customBody ? {'row-click': (e, row) => this.openRowView(row, e?.target?.closest?.('tr'))} : {}),
        ...(this.clientPageSize ? {'update:pagination': (value) => (this.clientPagination = value)} : {}),
      }"
    >
      <template v-slot:top v-if="(this.showSearch || this.showHeaderAdd) && !this.pageMode">
        <div class="q-table__title" v-if="!!title">{{title}}</div>
        <slot name="top-after-title"></slot>
        <q-space style="width: 15px" />
        <div class="actions">
          <CustomInput
            v-if="this.showSearch"
            :value="effectiveSearchTerm"
            :isSearch="true"
            placeholder="Поиск"
            v-debounce:300="this.onSearchChange"
          />
          <q-btn
            v-if="this.showHeaderAdd"
            size="md"
            title="Добавить"
            color="primary"
            :disable="this.headerAddDisabled"
            dense
            @click="() => onAddClick && onAddClick()"
            icon="add"
          />
          <q-btn
            class="actions__btn"
            v-if="this.updateData"
            @click="this.updateData"
          >
            <i class="material-icons actions__update"> refresh </i>
          </q-btn>
          <q-btn
            v-if="this.rowViewEnabled"
            dense
            flat
            icon="fa-solid fa-eye"
            :class="['actions__view', {'actions__view--active': this.rowViewMode}]"
            @click="this.toggleRowViewMode"
          >
            <q-tooltip>Режим просмотра: нажмите на строку, чтобы увидеть все поля</q-tooltip>
          </q-btn>
        </div>
      </template>
      <template v-if="this.$slots['top-right'] && !this.pageMode" v-slot:top-right="props">
        <slot name="top-right"></slot>
      </template>
      <template v-slot:no-data="{ icon, message, filter }">
        <div class="full-width row flex-center q-gutter-sm">
          <span>
            {{ message }}
          </span>
          <q-icon size="2em" :name="filter ? 'filter_b_and_w' : icon" />
        </div>
      </template>

      <template v-if="this.columnsResizable" v-slot:header-cell="props">
        <q-th :props="props" :style="this.columnWidths ? {width: `${this.columnWidths[props.col.name]}px`} : {}">
          {{ props.col.label }}
          <span
            class="custom-table__resize"
            title="Потяните, чтобы изменить ширину"
            @pointerdown.stop.prevent="(e) => this.startColumnResize(e, props.col.name)"
          />
        </q-th>
      </template>
      <template v-if="customHeader" v-slot:header="props">
        <slot name="customHeader" v-bind="props"></slot>
      </template>
      <template v-if="checkbox || expand || addBtn" v-slot:header="props">
        <q-tr :props="props">
          <q-th auto-width v-if="checkbox">
            <CustomCheckbox
              :value="checkboxValue"
              @change="(e) => onAllCheckClick && onAllCheckClick(e)"
            />
          </q-th>
          <q-th v-for="col in props.cols" :key="col.name" :props="props">
            {{ col.label }}
          </q-th>
          <q-th auto-width v-if="expand">
            <q-btn
              size="sm"
              title="Закрыть все"
              color="primary"
              round
              dense
              unelevated
              @click="() => onAllExpandClick && onAllExpandClick()"
              icon="remove"
            />
          </q-th>
          <q-th auto-width v-else-if="addBtn">
            <q-btn
              size="sm"
              :title="!!this.addBtnTitle ? '' : 'Добавить'"
              color="primary"
              round
              dense
              unelevated
              @click="() => onAddClick && onAddClick()"
              icon="add"
            >
              <q-tooltip
                v-if="!!this.addBtnTitle"
                >{{ this.addBtnTitle }}</q-tooltip
              >
            </q-btn>
          </q-th>
        </q-tr>
      </template>

      <template v-if="customBody" v-slot:body="props">
        <RowViewProxy v-if="this.rowViewMode" :active="true" :row="props.row" :on-open="this.openRowView">
          <slot name="customBody" v-bind="{...props, onExpandClick, openRowView}"></slot>
        </RowViewProxy>
        <slot v-else name="customBody" v-bind="{...props, onExpandClick, openRowView}"></slot>
      </template>
      <template v-if="this.bottomRow" v-slot:bottom-row="props">
        <slot name="bottomRow" v-bind="{...props}"></slot>
      </template>
    </q-table>

    <!-- progressiveRender: строки дорисовываются порциями, когда низ списка подходит к экрану
         (включается явно на тяжёлых длинных списках) -->
    <div v-if="this.progressive && this.renderLimit < (computedRowsData?.length || 0)" ref="moreSentinel" class="custom-table__more" />

    <!-- Режим просмотра строки: все поля таблицы в боковой панели. Данные — из уже загруженной строки, без запроса к бэку.
         Открывается кнопкой «Просмотр» в панели (клик по строке) или openRowView(row) из слота customBody;
         подпись и значение берутся из columns (label + viewValue(row) / format / field / name),
         колонки без подписи или с viewHidden не показываются. -->
    <q-dialog v-model="this.rowViewOpen" position="right" full-height class="row-view__dialog">
      <div class="row-view">
        <header class="row-view__head">
          <div class="row-view__titles">
            <div v-if="!!title" class="row-view__kicker">{{ title }}</div>
            <h2 class="row-view__title">{{ this.rowViewTitle }}</h2>
          </div>
          <button type="button" class="ms-icon-btn row-view__close" title="Закрыть" v-close-popup>
            <i class="fa-solid fa-xmark" aria-hidden="true" />
          </button>
        </header>
        <dl class="row-view__list">
          <div v-for="item in this.rowViewItems" :key="item.name" class="row-view__item">
            <dt>{{ item.label }}</dt>
            <dd :class="{ 'row-view__empty': item.empty }">{{ item.text }}</dd>
          </div>
        </dl>
        <footer v-if="this.onRowViewEdit" class="row-view__foot">
          <button type="button" class="ms-btn ms-btn--primary" @click="this.editFromView">
            <i class="fa-solid fa-pen" aria-hidden="true" /> Изменить
          </button>
        </footer>
      </div>
    </q-dialog>

    <!-- pageMode: горизонтальная полоса прокрутки, прижатая к низу экрана, пока низ широкой таблицы
         не виден (иначе родная полоса оказывается в самом конце длинного списка). -->
    <div
      v-if="this.pageMode"
      ref="hScrollBar"
      class="custom-table__hscroll"
      style="display: none"
      @scroll="this.onHScrollBar"
    >
      <div ref="hScrollInner" style="height: 1px" />
    </div>

    <span
      v-if="!this.pageMode && !this.showPagination && !this.hideFooterTitle && this.paginationPosition === 'bottom'"
      class="pagination__title"
      >{{ this.paginationTitle }}</span
    >

    <div
      v-if="this.showPagination && !!computedRowsData?.length"
      class="row justify-center bi-align-center q-mt-md pagination"
    >
      <q-pagination
        v-model="pagination.page"
        color="grey-8"
        @update:model-value="handlePaginationChange"
        :max="pagesNumber"
        max-pages="6"
        size="sm"
      />
      <span
        v-if="this.paginationPosition === 'bottom'"
        class="pagination__title"
        >{{ this.paginationTitle }}</span
      >
    </div>

    <div
      v-if="this.clientPageSize && this.clientPagesCount > 1"
      class="row justify-center bi-align-center q-mt-md pagination"
    >
      <q-pagination
        :model-value="this.clientPagination.page"
        color="grey-8"
        @update:model-value="this.setClientPage"
        :max="this.clientPagesCount"
        max-pages="6"
        size="sm"
      />
    </div>
  </div>
</template>

<script>
import CustomLoader from "@/components/common/CustomLoader";
import CustomInput from "@/components/form/CustomInput";
import {filteredGroupRowsData, filteredRowsData} from "@/components/common/CustomTable/services";
import CustomCheckbox from "@/components/form/CustomCheckbox";
import {getPaginationTableTitle} from "@/services";
import RowViewProxy from "@/components/common/CustomTable/row-view-proxy";

const RENDER_BATCH = 60
const MIN_COLUMN_WIDTH = 40

export default {
  name: "CustomTable",
  components: {CustomCheckbox, CustomInput, CustomLoader, RowViewProxy},
  // таблица внутри модалки (components/modal) остаётся компактной — со своей прокруткой
  // и вложенная таблица (внутри строки другой CustomTable) — тоже
  inject: {
    inModal: {from: "msInModal", default: false},
    inTable: {from: "msInTable", default: false},
    // страница, где все таблицы — основные списки (вкладки заявки): страничный режим без явного флага
    pageTables: {from: "msPageTables", default: false},
  },
  provide: {msInTable: true},
  props: [
    "expand",
    "checkbox",
    "addBtn",
    "customHeader",
    "addBtnTitle",
    "showHeaderAdd",
    "headerAddDisabled",
    "dense",
    "checkboxValue",
    "customBody",
    "title",
    "rowsData",
    "rowsDataGroupMode",
    "groupProps",
    "stickyHeader",
    "stickyLastColumn",
    "onAllCheckClick",
    "onAllExpandClick",
    "onAddClick",
    "columns",
    "showPagination",
    "paginationPosition",
    "hideFooterTitle",
    "hideTopTitle",
    "onPaginationChange",
    "pageHeaderHeight",
    "getDetailData",
    "showSearch",
    "useExternalSearch",
    "externalSearchTerm",
    "callDetailWhenExpand",
    "rowKey",
    "striped",
    "small",
    "smallFont",
    "loading",
    "updateData",
    "pagesNumber",
    "count",
    "bottomRow",
    "allWidth",
    "separator",
    "hoverless",
    "bordered",
    "marginTop",
    "withoutHead",
    "naturalHeight",
    "virtualScroll",
    "virtualScrollItemSize",
    "pageScroll",
    "pageStickyHeader",
    "clientPageSize",
    "progressiveRender",
    "rowView",
    "onRowViewEdit",
    "resizableColumns",
  ],
  data() {
    return {
      searchTerm: "",
      itemsLoading: {},
      searchInput: "",
      renderLimit: RENDER_BATCH,
      rowViewOpen: false,
      rowViewRow: null,
      rowViewCells: [],
      rowViewMode: false,
      inDialog: false,
      pageModeState: null,
      columnWidths: null,
      pagination: {
        page: 1,
        rowsPerPage: 100,
        sortBy: "desc",
        descending: false,
      },
      clientPagination: {
        page: 1,
        rowsPerPage: Number(this.clientPageSize) || 0,
        sortBy: null,
        descending: false,
      },
    };
  },
  computed: {
    // client-page-size: все строки уже на клиенте, страницы нарезает q-table — после поиска и сортировки по всем строкам
    clientPagesCount() {
      return Math.ceil((this.computedRowsData?.length || 0) / this.clientPagination.rowsPerPage)
    },
    // Страничный режим (условия — computePageMode) определяется один раз при создании таблицы: если пропсы потом меняются
    // (например, кнопка «Добавить» появляется после выбора строки), вид таблицы не перескакивает
    pageMode() {
      return this.pageModeState === null ? this.computePageMode() : this.pageModeState
    },
    rowViewEnabled() {
      return this.rowView !== false && !!this.columns?.some(c => !!c.label)
    },
    // Ширина колонок мышью: resizable-columns="ключ" (под ним ширины запоминаются в браузере).
    // Только со стандартной шапкой таблицы
    columnsResizable() {
      return !!this.resizableColumns && !this.customHeader && !this.checkbox && !this.expand && !this.addBtn
    },
    columnWidthsKey() {
      return `msTableColumns:${this.resizableColumns}`
    },
    columnWidthsVars() {
      if (!this.columnWidths) return {}
      return {'--ct-table-width': `${this.sumColumnWidths(this.columnWidths)}px`}
    },
    countLabel() {
      if (this.showPagination) return this.count || 0
      const total = this.rowsData?.length || 0
      const shown = this.computedRowsData?.length || 0
      return shown === total ? total : `${shown} из ${total}`
    },
    paginationTitle() {
      if (!this.showPagination) return `Количество: ${this.rowsData?.length || 0}`
      return getPaginationTableTitle('', this.pagination.rowsPerPage, this.count, this.pagination.page)
    },
    effectiveSearchTerm() {
      if (this.useExternalSearch) {
        return this.externalSearchTerm != null ? String(this.externalSearchTerm) : "";
      }
      return this.searchTerm;
    },
    tablePagination() {
      if (this.clientPageSize) return this.clientPagination
      if (this.showPagination) return this.pagination
      if (this.virtualScroll) return { rowsPerPage: 0 }
      return { rowsPerPage: 10000 }
    },
    rowViewTitle() {
      const row = this.rowViewRow
      if (!row) return ''
      const titled = this.columns?.find(c => c.viewTitle)
      if (titled) return this.formatViewValue(this.columnViewValue(titled, row))
      // иначе — первое текстовое поле, похожее на название (не ID и не число)
      const col = this.columns?.find(c => {
        const v = this.columnViewValue(c, row)
        return !!c.label && !c.viewHidden && typeof v === 'string' && v.trim() && isNaN(Number(v))
      })
      return col ? this.formatViewValue(this.columnViewValue(col, row)) : ''
    },
    rowViewItems() {
      const row = this.rowViewRow
      if (!row) return []
      return (this.columns || [])
        .map((c, i) => {
          if (!c.label || c.viewHidden || c.name === 'actions') return null
          // значение из данных строки; если колонка описана с полем, которого в данных нет
          // (опечатка, другой регистр, вычисляемая ячейка) — берём то, что видно в ячейке таблицы
          const known = !!c.viewValue || typeof c.field === 'function' || this.rowKeyFor(c, row) !== null
          const text = known ? this.formatViewValue(this.columnViewValue(c, row)) : (this.rowViewCells[i] || '')
          if (!known && !this.rowViewCells.length) return null
          return { name: c.name, label: c.label, text: text || '—', empty: !text }
        })
        .filter(Boolean)
    },
    // Порционный вывод строк — только по явному флагу progressive-render (без пагинации и virtual-scroll):
    // поиск и счётчик по-прежнему работают по всем данным.
    progressive() {
      return !!this.progressiveRender && !this.showPagination && !this.virtualScroll
    },
    renderedRowsData() {
      const rows = this.computedRowsData || []
      return this.progressive ? rows.slice(0, this.renderLimit) : rows
    },
    computedRowsData() {
      const term = this.effectiveSearchTerm;
      if (!term) return this.rowsData;
      if (this.rowsDataGroupMode)
        return filteredGroupRowsData(this.columns, this.rowsData, term, this.groupProps);
      return filteredRowsData(this.columns, this.rowsData, term);
    },
    maxHeightData() {
      if (this.naturalHeight || this.pageMode) {
        return "initial";
      }
      const screenHeight = window.innerHeight
      const margin = 15
      const pagination = this.showPagination ? 30 : 0
      if (screenHeight < 730 && this.pageHeaderHeight > 300)
        return '600px'
      let totalHeight = screenHeight - 98 - (this.pageHeaderHeight || 0) - pagination - margin
      if(totalHeight < 500) totalHeight = 500
      return this.stickyHeader ? `${totalHeight}px` : 'initial'
    }
  },
  watch: {
    // новый набор данных или новый поиск — снова с первой порции
    effectiveSearchTerm(value) {
      this.renderLimit = RENDER_BATCH
      // внешний поиск (useExternalSearch) мог поменяться снаружи — показываем его в поле, если пользователь не печатает
      if (!this.searchTimer && value !== this.searchInput) this.searchInput = value
    },
    renderLimit() {
      this.$nextTick(this.observeMore)
    },
    "computedRowsData.length"() {
      this.$nextTick(this.observeMore)
    },
    computedRowsData() {
      if (this.clientPageSize) this.clientPagination = {...this.clientPagination, page: 1}
    },
  },
  created() {
    this.pageModeState = this.computePageMode()
    this.columnWidths = this.readColumnWidths()
  },
  mounted() {
    this.searchInput = this.effectiveSearchTerm
    // таблица в собственном q-dialog страницы (не через components/modal) — тоже без страничного режима
    if (this.$el?.closest?.('.q-dialog')) {
      this.inDialog = true
      this.pageModeState = false
    }
    if (this.progressive) {
      this.moreObserver = new IntersectionObserver((entries) => {
        if (entries.some(e => e.isIntersecting)) this.renderMore()
      }, {rootMargin: '800px 0px'})
      this.$nextTick(this.observeMore)
    }
    if (!this.pageMode) return
    this.hScrollMiddle = this.$el.querySelector('.q-table__middle')
    if (!this.hScrollMiddle) return
    this.updateHScroll = this.scheduleHScroll.bind(this)
    this.onTableHScroll = this.onTableHScroll.bind(this)
    window.addEventListener('scroll', this.updateHScroll, {passive: true})
    window.addEventListener('resize', this.updateHScroll)
    this.hScrollMiddle.addEventListener('scroll', this.onTableHScroll, {passive: true})
    this.hScrollObserver = new ResizeObserver(this.updateHScroll)
    this.hScrollObserver.observe(this.hScrollMiddle)
    if (this.hScrollMiddle.firstElementChild) this.hScrollObserver.observe(this.hScrollMiddle.firstElementChild)
    this.updateHScroll()
  },
  beforeUnmount() {
    this.stopColumnResize?.()
    clearTimeout(this.searchTimer)
    cancelAnimationFrame(this.hScrollFrame)
    this.moreObserver?.disconnect()
    if (!this.hScrollMiddle) return
    window.removeEventListener('scroll', this.updateHScroll)
    window.removeEventListener('resize', this.updateHScroll)
    this.hScrollMiddle.removeEventListener('scroll', this.onTableHScroll)
    this.hScrollObserver?.disconnect()
  },
  methods: {
    // Страничный режим: явно (page-scroll) или сам — для основного списка страницы вне модалок,
    // диалогов и других таблиц: с прилипающей шапкой или с заголовком и поиском/«Добавить»
    computePageMode() {
      if (this.pageScroll === false || this.virtualScroll) return false
      if (this.pageScroll === true || this.pageScroll === 'true') return true
      if (this.inModal || this.inTable || this.inDialog) return false
      if (this.pageTables) return true
      const sticky = this.stickyHeader === true || this.stickyHeader === 'true'
      const mainList = !!this.title && (!!this.showSearch || !!this.showHeaderAdd)
      return sticky || mainList
    },
    toggleRowViewMode() {
      this.rowViewMode = !this.rowViewMode
    },
    sumColumnWidths(widths) {
      return Object.values(widths).reduce((sum, width) => sum + width, 0)
    },
    // сохранённые ширины подходят, только если есть для всех колонок (колонки могли поменяться)
    readColumnWidths() {
      if (!this.columnsResizable) return null
      try {
        const saved = JSON.parse(localStorage.getItem(this.columnWidthsKey))
        if (!saved || !this.columns?.every(c => Number(saved[c.name]) > 0)) return null
        return Object.fromEntries(this.columns.map(c => [c.name, Number(saved[c.name])]))
      } catch (e) {
        return null
      }
    },
    saveColumnWidths() {
      try {
        if (this.columnWidths) localStorage.setItem(this.columnWidthsKey, JSON.stringify(this.columnWidths))
        else localStorage.removeItem(this.columnWidthsKey)
      } catch (e) {
        // без хранилища ширины просто не запомнятся
      }
    },
    resetColumnWidths() {
      this.columnWidths = null
      this.saveColumnWidths()
    },
    // Пока тянем — пишем ширину прямо в DOM (как полоса прокрутки ниже): иначе на каждое движение
    // перерисовывались бы все строки. В состояние и в браузер — один раз, когда отпустили.
    startColumnResize(e, name) {
      const cells = [...this.$el.querySelectorAll('.q-table__middle > .q-table > thead > tr:first-child > th')]
      const cell = cells[this.columns.findIndex(c => c.name === name)]
      if (!cell) return
      // первое перетаскивание фиксирует текущие ширины всех колонок, дальше меняется только одна
      const widths = this.columnWidths
        || Object.fromEntries(this.columns.map((c, i) => [c.name, Math.round(cells[i].getBoundingClientRect().width)]))
      this.columnWidths = widths
      const startX = e.clientX
      const startWidth = widths[name]
      const othersWidth = this.sumColumnWidths(widths) - startWidth
      let width = startWidth
      const onMove = (event) => {
        width = Math.max(MIN_COLUMN_WIDTH, startWidth + event.clientX - startX)
        cell.style.width = `${width}px`
        this.$el.style.setProperty('--ct-table-width', `${othersWidth + width}px`)
      }
      const onUp = () => {
        this.stopColumnResize()
        this.columnWidths = {...widths, [name]: width}
        this.saveColumnWidths()
        // клик после отпускания не должен сортировать колонку
        const swallowClick = (event) => event.stopPropagation()
        window.addEventListener('click', swallowClick, true)
        setTimeout(() => window.removeEventListener('click', swallowClick, true))
      }
      this.stopColumnResize = () => {
        window.removeEventListener('pointermove', onMove)
        window.removeEventListener('pointerup', onUp)
        window.removeEventListener('pointercancel', onUp)
        document.body.classList.remove('custom-table--resizing')
        this.stopColumnResize = null
      }
      window.addEventListener('pointermove', onMove)
      window.addEventListener('pointerup', onUp)
      window.addEventListener('pointercancel', onUp)
      document.body.classList.add('custom-table--resizing')
    },
    // значение колонки для панели просмотра: viewValue(row) → field (строка или функция) → поле с именем колонки;
    // если у колонки есть format (Quasar) — применяем его
    columnViewValue(col, row) {
      if (col.viewValue) return col.viewValue(row)
      let value
      if (typeof col.field === 'function') value = col.field(row)
      else {
        const key = this.rowKeyFor(col, row)
        if (key !== null) value = row[key]
      }
      return typeof col.format === 'function' ? col.format(value, row) : value
    },
    // ключ строки для колонки: field, затем name, затем то же без учёта регистра (Email → email)
    rowKeyFor(col, row) {
      const candidates = [col.field, col.name].filter(k => typeof k === 'string' && k)
      for (const k of candidates) if (k in row) return k
      const keys = Object.keys(row)
      for (const k of candidates) {
        const found = keys.find(key => key.toLowerCase() === k.toLowerCase())
        if (found) return found
      }
      return null
    },
    // тексты ячеек строки по порядку колонок — запасной источник для панели просмотра
    readRowCells(tr) {
      if (!tr) return []
      const offset = this.checkbox ? 1 : 0
      const cells = [...tr.children].filter(el => el.tagName === 'TD')
      if (cells.length < (this.columns?.length || 0) + offset) return []
      // текст ячейки без иконок и кнопок (иначе в просмотр попадут «edit», «delete» из иконок)
      return this.columns.map((c, i) => {
        const cell = cells[i + offset]
        if (!cell || c.name === 'actions') return ''
        const copy = cell.cloneNode(true)
        copy.querySelectorAll('.q-icon, .material-icons, i, button, .q-btn, .q-tooltip, .q-menu').forEach(el => el.remove())
        return (copy.textContent || '').replace(/\s+/g, ' ').trim()
      })
    },
    // строка таблицы для данных row, когда открытие пришло не из клика по строке (кнопка «глаз»)
    findRowElement(row) {
      const index = this.renderedRowsData.indexOf(row)
      const body = this.$el?.querySelector('.q-table__middle > .q-table > tbody')
      const trs = body ? [...body.children].filter(el => el.tagName === 'TR') : []
      return index >= 0 && trs.length === this.renderedRowsData.length ? trs[index] : null
    },
    openRowView(row, tr) {
      this.rowViewRow = row
      this.rowViewCells = this.readRowCells(tr || this.findRowElement(row))
      this.rowViewOpen = true
    },
    editFromView() {
      const row = this.rowViewRow
      this.rowViewOpen = false
      this.onRowViewEdit && this.onRowViewEdit(row)
    },
    // значение поля для просмотра: HTML из БД — в текст, логические — «Да/Нет», пустые — «—»
    formatViewValue(value) {
      if (value === null || value === undefined || value === '') return ''
      if (typeof value === 'boolean') return value ? 'Да' : 'Нет'
      if (typeof value === 'object') return JSON.stringify(value)
      return String(value)
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<[^>]*>/g, '')
        .replace(/\n{2,}/g, '\n')
        .trim()
    },
    observeMore() {
      if (!this.moreObserver) return
      this.moreObserver.disconnect()
      if (this.$refs.moreSentinel) this.moreObserver.observe(this.$refs.moreSentinel)
    },
    renderMore() {
      const total = this.computedRowsData?.length || 0
      if (this.renderLimit < total) this.renderLimit = Math.min(this.renderLimit + RENDER_BATCH, total)
    },
    // не чаще раза за кадр; состояние полосы не реактивное — пишем прямо в DOM,
    // чтобы прокрутка страницы не перерисовывала таблицу
    scheduleHScroll() {
      if (this.hScrollFrame) return
      this.hScrollFrame = requestAnimationFrame(() => {
        this.hScrollFrame = 0
        this.applyHScroll()
        this.applyPageStickyHead()
      })
    },
    // page-sticky-header: шапка остаётся под верхней панелью сайта при прокрутке страницы.
    // position: sticky не сработает — таблица внутри контейнера с прокруткой вбок, поэтому сдвигаем thead
    applyPageStickyHead() {
      if (!this.pageStickyHeader) return
      const middle = this.hScrollMiddle
      const head = middle?.querySelector(':scope > .q-table > thead')
      if (!head) return
      const rect = middle.getBoundingClientRect()
      const shift = Math.max(0, Math.min(this.siteHeaderBottom() - rect.top, rect.height - head.offsetHeight))
      head.style.transform = shift ? `translateY(${shift}px)` : ''
    },
    siteHeaderBottom() {
      return document.querySelector('.q-header')?.getBoundingClientRect().bottom || 0
    },
    // новую страницу показываем с начала: кнопки страниц внизу таблицы, а строк на странице много
    setClientPage(page) {
      this.clientPagination = {...this.clientPagination, page}
      this.$nextTick(() => {
        const top = this.$el.querySelector('.q-table__middle')?.getBoundingClientRect().top
        const headerBottom = this.siteHeaderBottom()
        if (top < headerBottom) window.scrollBy(0, top - headerBottom)
      })
    },
    applyHScroll() {
      const middle = this.hScrollMiddle
      const bar = this.$refs.hScrollBar
      if (!middle || !bar) return
      const rect = middle.getBoundingClientRect()
      const overflow = middle.scrollWidth > middle.clientWidth + 1
      const visible = overflow && rect.top < window.innerHeight - 40 && rect.bottom > window.innerHeight
      const wasVisible = bar.style.display !== 'none'
      if (!visible) {
        if (wasVisible) bar.style.display = 'none'
        return
      }
      bar.style.left = `${rect.left}px`
      bar.style.width = `${rect.width}px`
      this.$refs.hScrollInner.style.width = `${middle.scrollWidth}px`
      if (!wasVisible) {
        bar.style.display = 'block'
        bar.scrollLeft = middle.scrollLeft
      }
    },
    onTableHScroll() {
      if (this.$refs.hScrollBar) this.$refs.hScrollBar.scrollLeft = this.hScrollMiddle.scrollLeft
    },
    onHScrollBar(e) {
      if (this.hScrollMiddle) this.hScrollMiddle.scrollLeft = e.target.scrollLeft
    },
    async onExpandClick(id, expand) {
      if (!this.callDetailWhenExpand && !expand) return;
      this.itemsLoading[id] = true;
      await this.getDetailData(id, expand);
      this.itemsLoading[id] = false;
    },
    handlePaginationChange(page) {
      this.pagination.page = page;
      this.onPaginationChange(page);
    },
    onSearchInput(value) {
      this.searchInput = value
      clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(() => {
        this.searchTimer = null
        this.onSearchChange(value)
      }, 300)
    },
    clearSearch() {
      clearTimeout(this.searchTimer)
      this.searchTimer = null
      this.searchInput = ''
      this.onSearchChange('')
    },
    onSearchChange(value) {
      if (this.useExternalSearch) {
        this.$emit("update:externalSearchTerm", value != null ? String(value) : "");
        return;
      }
      this.searchTerm = value;
    },
  },
};
</script>

<style lang="scss">
// Вид таблиц как в app.buildest.kz: карточка со скруглением и мягкой тенью, светлая шапка
// с жирными заголовками, тонкие разделители строк. Цвета — из assets/styles/theme.scss.
.custom-table {
  --tbl-radius: var(--ms-radius);
  --tbl-head-bg: var(--ms-primary-50);
  --tbl-head-text: var(--ms-primary-ink);
  --tbl-head-line: var(--ms-primary-100);
  --tbl-row: var(--ms-surface);
  --tbl-row-hover: var(--ms-row-hover);
  --tbl-divider: var(--ms-divider);
  --tbl-text: var(--ms-text);
  z-index: 0;
  border: none !important;
  border-radius: var(--tbl-radius) !important;
  overflow: hidden;
  box-shadow: var(--ms-shadow-card) !important;
  font-size: 13px;

  .q-table__title {
    font-size: 16px;
    font-weight: 700;
    color: var(--tbl-head-text);
  }

  .q-table__top {
    background-color: var(--ms-surface);
    border-bottom: 1px solid var(--tbl-divider);
  }

  .q-table__bottom {
    border: none;
  }

  // Линии сетки — едва заметные; вертикальные остаются для сгруппированных шапок.
  .q-table th,
  .q-table td {
    border-color: var(--tbl-divider);
  }

  &__bordered {
    border: 1px solid #e0e0e0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;

    .q-table th,
    .q-table td {
      border-color: rgba(0, 0, 0, 0.12);
    }
  }

  .q-table thead {
    background: var(--tbl-head-bg);
    tr {
      th {
        position: relative;
        background: var(--tbl-head-bg);
        color: var(--tbl-head-text);
        font-size: 13px;
        font-weight: 700;
        padding: 9px 12px;
        border-bottom: 2px solid var(--tbl-head-line) !important;
      }

      th.sortable {
        padding-right: 15px !important;
        transition: all 0.1s;

        &:hover {
          background-color: var(--ms-primary-100);
        }

        &.text-right {
          padding-right: 8px !important;
          padding-left: 15px !important;

          i {
            right: unset;
            left: 2px;
          }
        }

        i {
          font-size: 100% !important;
          margin-left: 0;
          position: absolute;
          right: 2px;
          vertical-align: middle;
          top: calc(100% - 50% - 6px);
        }
      }
    }
  }

  // small / smallFont больше не уменьшают шрифт и отступы: все таблицы выглядят одинаково

  tbody {
    tr {
      background: var(--tbl-row);
      &:hover {
        background: var(--tbl-row-hover) !important;
      }
      td {
        position: relative;
        padding: 8px 12px !important;
        vertical-align: middle;
        color: var(--tbl-text);
        font-size: 13px;
      }
    }
  }
  &__hoverless {
    tbody {
      tr {
        &:hover {
          background-color: '' !important;
          td::before {
            background-color: '' !important;
            content: initial !important
          }
        }
      }
    }
  }
}

// Режим pageScroll: строки в одну линию, длинный текст обрезается многоточием,
// широкая таблица прокручивается по горизонтали внутри карточки.
.custom-table--page {
  > .q-table__middle > .q-table > thead > tr > th {
    height: auto;
    white-space: nowrap;
  }

  // только строки этой таблицы (не вложенных); строки-детали (td с colspan) не обрезаем
  > .q-table__middle > .q-table > tbody > tr > td:not([colspan]) {
    height: auto;
    max-width: 320px;
    vertical-align: middle;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  > .q-table__middle > .q-table > tbody > tr:last-child > td {
    border-bottom: none;
  }

  // поля, чекбоксы и кнопки в ячейках — компактные, чтобы строка оставалась одной высоты с остальными
  > .q-table__middle > .q-table > tbody > tr > td:not([colspan]) {
    &:has(.q-checkbox, .mx-datepicker, .q-field, .q-btn) {
      padding-top: 4px !important;
      padding-bottom: 4px !important;
    }

    .q-checkbox__inner {
      font-size: 30px;
    }

    .mx-datepicker input {
      min-height: 30px !important;
      height: 30px;
    }
  }
}

// page-sticky-header: сдвинутая шапка поверх строк (у td position: relative, иначе они рисуются сверху)
.custom-table--page-sticky-head > .q-table__middle > .q-table > thead {
  position: relative;
  z-index: 2;
}

// Ширина колонок мышью (resizable-columns). После первого перетаскивания таблица шириной ровно в сумму
// колонок: другие колонки при этом не сдвигаются по ширине, лишнее уходит в прокрутку вбок.
.custom-table--resizable > .q-table__middle > .q-table > thead > tr > th {
  overflow: hidden;
  text-overflow: ellipsis;
}

.custom-table--resized > .q-table__middle > .q-table {
  table-layout: fixed;
  width: var(--ct-table-width);
  min-width: 0 !important;
  max-width: none;
}

.custom-table__resize {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 9px;
  cursor: col-resize;
  touch-action: none;

  &::after {
    content: "";
    position: absolute;
    top: 25%;
    right: 3px;
    bottom: 25%;
    width: 2px;
    border-radius: 2px;
    background: var(--ms-primary-100);
  }

  &:hover::after {
    top: 0;
    bottom: 0;
    background: var(--ms-primary);
  }
}

body.custom-table--resizing {
  cursor: col-resize;
  user-select: none;
}

// ---------- Единый вид содержимого ячеек (как в таблице «Подрядчики») ----------
.custom-table .q-table td {
  // иконки действий (CustomIcon) — квадратные кнопки: правка — синяя, удаление — красная;
  // информационные иконки (info, user, history — обычно с подсказкой) остаются значками
  .q-icon.icon:not(.icon__info):not(.icon__user):not(.icon__history) {
    width: 26px;
    height: 26px;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    vertical-align: middle;
    border-radius: 6px;
    background: var(--ms-primary-100);
    color: var(--ms-primary);
    font-size: 13px !important;
    transition: background 0.15s, color 0.15s;

    &:hover {
      background: var(--ms-primary);
      color: #fff;
    }

    &.icon__trash,
    &.icon__red {
      background: var(--ms-danger-bg);
      color: var(--ms-danger);

      &:hover {
        background: var(--ms-danger);
        color: #fff;
      }
    }

    &.icon__green {
      background: var(--ms-success-bg);
      color: var(--ms-success);

      &:hover {
        background: var(--ms-success);
        color: #fff;
      }
    }

    &.icon__small {
      width: 22px;
      height: 22px;
      font-size: 11px !important;
    }
  }

  // обычные ссылки в ячейках — как Clickable: без подчёркивания, синие полужирные
  a:not(.q-btn) {
    color: var(--ms-primary);
    font-weight: 600;
    text-decoration: none;

    &:hover {
      color: var(--ms-primary-hover);
      text-decoration: underline;
    }
  }

  // кнопки в ячейках — без капслока, аккуратные
  .q-btn:not(.q-btn--round) {
    border-radius: var(--ms-radius-sm);
    text-transform: none;
    font-weight: 600;
    letter-spacing: 0;
  }

  // метки (q-chip, q-badge) — «таблетки» как ms-badge
  .q-chip {
    min-height: 22px;
    height: auto;
    margin: 2px 4px 2px 0;
    padding: 0 9px;
    border-radius: 9999px;
    font-size: 11px;
    font-weight: 600;
  }

  .q-badge {
    padding: 2px 8px;
    border-radius: 9999px;
    font-size: 11px;
    font-weight: 600;
    line-height: 16px;
  }
}

// Режим просмотра: строки кликабельны целиком
.custom-table--viewmode tbody tr.row-view-target,
.custom-table--viewmode tbody tr {
  cursor: pointer;
}

.custom-table--viewmode tbody tr:hover td {
  background: var(--ms-primary-50) !important;
}

.custom-table__view-hint {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: -4px 0 10px;
  padding: 7px 10px 7px 12px;
  border-radius: var(--ms-radius-sm);
  background: var(--ms-primary-50);
  color: var(--ms-primary-ink);
  font-size: 12px;

  .ms-search__clear {
    position: static;
    transform: none;
    margin-left: auto;
  }
}

.actions__view {
  color: var(--ms-muted);

  &--active {
    color: var(--ms-primary);
    background: var(--ms-primary-100);
  }
}

.row-view {
  width: 440px;
  max-width: 100vw;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: var(--ms-surface);
  box-shadow: -8px 0 32px rgba(15, 23, 42, 0.14);

  &__head {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 18px 20px 14px;
    border-bottom: 1px solid var(--ms-divider);
  }

  &__titles {
    flex: 1;
    min-width: 0;
  }

  &__kicker {
    font-size: 12px;
    color: var(--ms-muted);
  }

  &__title {
    margin: 2px 0 0;
    font-size: 18px;
    line-height: 24px;
    font-weight: 700;
    color: var(--ms-primary-ink);
    overflow-wrap: anywhere;
  }

  &__close {
    width: 30px;
    height: 30px;
    font-size: 13px;
  }

  &__list {
    flex: 1;
    margin: 0;
    padding: 6px 20px 16px;
    overflow-y: auto;
  }

  &__item {
    display: grid;
    grid-template-columns: 150px minmax(0, 1fr);
    gap: 12px;
    padding: 9px 0;
    border-bottom: 1px solid var(--ms-divider);
    font-size: 13px;
    line-height: 19px;

    &:last-child {
      border-bottom: none;
    }

    dt {
      color: var(--ms-muted);
    }

    dd {
      margin: 0;
      color: var(--ms-text);
      white-space: pre-line;
      overflow-wrap: anywhere;
      user-select: text;
    }
  }

  &__empty {
    color: var(--ms-muted) !important;
  }

  &__foot {
    display: flex;
    justify-content: flex-end;
    padding: 12px 20px;
    border-top: 1px solid var(--ms-divider);
  }

  @media (max-width: 576px) {
    width: 100vw;

    &__item {
      grid-template-columns: minmax(0, 1fr);
      gap: 2px;
    }
  }
}

.custom-table__more {
  height: 1px;
}

.custom-table__hscroll {
  position: fixed;
  bottom: 0;
  z-index: 5;
  height: 14px;
  overflow-x: auto;
  overflow-y: hidden;
  background: rgba(255, 255, 255, 0.92);
  border-top: 1px solid var(--ms-border);
  scrollbar-width: auto;

  &::-webkit-scrollbar {
    height: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c3cad6;
    border-radius: 10px;
  }
}

.my-sticky-header-table {
  thead {
    tr {
      th {
        position: sticky !important;
        z-index: 1;
      }

      &:first-child th {
        top: 0;
      }
    }
  }
}
.sticky-last-column {
  thead {
    th:last-child {
      position: sticky;
      right: 0 !important;
      z-index: 2 !important;
    }
  }
  tbody {
    td:last-child {
      border-right: none;
      position: sticky;
      right: 0;
      z-index: 1;
    }
  }
}

.actions {
  display: flex;
  align-items: center;
  gap: 15px;

  &__btn {
    background-color: #3f66ad !important;
    color: #fff;
  }

  &__update {
    font-size: 20px !important;
    color: #fff !important;
  }

  .q-table__top,
  .q-table__bottom,
  thead tr:first-child th {
    background-color: #fff;
  }

  thead {
    tr {
      th {
        position: sticky !important;
        z-index: 1;
      }

      &:first-child th {
        top: 0;
      }
    }
  }

  &.q-table--loading {
    thead {
      tr:last-child th {
        top: 48px;
      }
    }
  }
}

@media (max-width: 768px) {
  .my-sticky-header-table {
    min-height: 550px !important;
  }
  .my-sticky-header-table.custom-table--natural {
    min-height: unset !important;
  }
}

.pagination {
  align-items: center;

  &__title {
    font-size: 11px;
    color: #616161;
    font-weight: 500;
    margin-left: 25px;
  }
}
</style>
